export default __webpack_public_path__ + "static/media/never-wet.b495d9b1.jpeg";